import { render, staticRenderFns } from "./distribute-task.vue?vue&type=template&id=933278a0"
import script from "./distribute-task.vue?vue&type=script&lang=js"
export * from "./distribute-task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports